'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Toolkit = require('./Toolkit.css');

var _Toolkit2 = _interopRequireDefault(_Toolkit);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolkit = (_dec = (0, _reactCssModules2.default)(_Toolkit2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Toolkit, _Component);

  function Toolkit(props) {
    (0, _classCallCheck3.default)(this, Toolkit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Toolkit.__proto__ || (0, _getPrototypeOf2.default)(Toolkit)).call(this, props));

    _this.renderToolkit401kGraphicWrap = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'content-photo-wrap' },
        _react2.default.createElement('div', { styleName: 'photo-graphic', title: '$5.1 Trillion are invested in 401ks - map of U.S. image' }),
        _react2.default.createElement(
          'div',
          { styleName: 'contents' },
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title-notopspace' },
            'If your investments are in your employer-sponsored plan at work'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            'It is possible to change what the plan offers, but it will take more effort than if you have an IRA or a personal investment that you solely control (see below). You will need to engage the plan administrator to help find the right blend of funds to satisfy the many employees that all invest in the same basket of mutual funds. This may take time and possibly some coordination with your co-plan participants.'
          )
        )
      );
    };

    _this.renderToolkitFundsPhotoWrap = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'content-photo-wrap' },
        _react2.default.createElement('div', { styleName: 'photo-funds', title: 'Mutual fund paperwork image' }),
        _react2.default.createElement(
          'div',
          { styleName: 'contents' },
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'If you\u2019re an individual investor'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'It\u2019s much easier to divest and reinvest; it\u2019s your money, and your financial advisor works for you. You just need to have a meeting to discuss what you have learned about your holdings and how you would like them changed to align with your values. An investment professional will advise you of potential risk and you can make your own decisions.'
            )
          )
        )
      );
    };

    _this.renderToolkitContent = function (toolkitTitle) {
      return _react2.default.createElement(
        'div',
        { styleName: 'toolkit' },
        _react2.default.createElement(
          'div',
          { styleName: 'toolkit-inner' },
          _react2.default.createElement(
            'h1',
            { styleName: 'title' },
            toolkitTitle
          ),
          _this.renderToolkit401kGraphicWrap(),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Step 1 \u2013 Talk to your colleagues and build a coalition'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'To effectively advocate for new offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you\u2019re writing to someone in power, advocating on behalf of 10 or even 20 people carries a lot more weight than just one. One way to spur interest would be sharing the results from your Tobacco Free Funds search among fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions right now.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Step 2 \u2013 Identify the best people to speak with'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'The 401(k)/403(b) plan administrator, manager, or coordinator should be known if you are a plan participant, and that\u2019s where to start. There could also be a chief sustainability officer or employee engagement manager, and those could be good resources. An effective method is to go to the LinkedIn pages of those people and find who might have some sympathy for the cause. Do any of them volunteer or have connections with organizations concerned with climate change? Look for indicators that they\u2019re friendly to sustainability and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it\u2019s an important issue for many employees. If it\u2019s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Step 3 \u2013 Bring a solution to the table'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'The usual starting point in these conversations is: \u201CWe want to reduce the future risk of our 401(k) fund choices. We also want to invest in a healthy future. How can we enhance our 401(k) choices to do so?\u201D Here are the criteria. Getting three new fund choices added to the list of the existing 15-30 is a formal process, and could take a year to be added. Larger companies often have some form of investment committee, which engages an investment advisor. There may be some funds in your plan that you see contain only one tobacco company or movie studio. You could ask the plan administrator to call the fund manager and say, \u201CIs there a substitute for this one tobacco company? If you made one change you would be tobacco free!\u201D'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If the investment advisor and plan administrator refuse to help in swapping out some tobacco heavy funds for some tobacco free funds, you may need to get fellow employees to sign a petition requesting the change and send it to the investment committee. If you are told, \u201CBut you\u2019ll make less money if you\u2019re not invested in tobacco.\u201D You can say, \u201CActually, tobacco is a risky investment. We want to diversify, and be part of a healthy future.\u201D (Check out ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.caTreasurer, xstrong: true, title: 'Statement from Treasurer John Chiang on CalPERS Tobacco Divestment Vote' },
                'this statement on tobacco divestment from the California State Treasurer.'
              ),
              ')'
            )
          ),
          _this.renderToolkitFundsPhotoWrap(),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'You can trade your own portfolio, or tell your manager to do it. They may push back and tell you that you\u2019ll make less money. Again, you can reply, \u201CMaybe, but it\u2019s my money, I want less risk, and tobacco is a risky business.\u201D It\u2019s financial advisors job to make you money, so you should drive home the point in no uncertain terms. Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to remove the risk, not a specific fund; focus on risk, especially future risk, as well as returns. If they\u2019re being lazy or unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.'
            )
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Toolkit, [{
    key: 'render',
    value: function render() {
      var title = 'Action Toolkit';
      var link = _config2.default.domain + _config2.default.routes.toolkit;
      var message = 'Talk to your employer about tobacco-free options for your retirement plan';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(title),
          this.renderToolkitContent(title)
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.DonateBanner, null),
        _react2.default.createElement(
          'div',
          { styleName: 'banner-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return Toolkit;
}(_react.Component)) || _class);
exports.default = Toolkit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Toolkit/Toolkit.js
// module id = 1300
// module chunks = 0